import type { HttpClient, RequestOptions, ResponseShape } from '../types/httpClient';

import { unwrapResponse } from './unwrapResponse';

/** Sends a request through the transport and unwraps the response shape. */
export async function send<T>(
    http: HttpClient,
    shape: ResponseShape,
    path: string,
    options?: RequestOptions,
): Promise<T> {
    return unwrapResponse<T>(await http.request<unknown>(path, options), shape);
}
